// client/src/components/plataforma/users/UserRow.js
import React, { useState } from 'react';
import { MoreVertical, Shield, Phone } from 'lucide-react';

const UserRow = ({ user, onOpenActions }) => {
    const [imgError, setImgError] = useState(false);

    const isAtivo = user.isActive && user.status !== 'inativo';
    const isExcluido = user.status === 'excluido';

    const getPhotoUrl = () => {
        if (imgError) {
             return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
        }
        
        if (user.photoUrl && typeof user.photoUrl === 'string' && user.photoUrl.length > 5) {
            return user.photoUrl;
        }
        
        if (user.photo && typeof user.photo === 'string' && user.photo.length > 5) {
            return user.photo;
        }
        
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
    };

    return (
        <tr className={`table-row-hover ${!isAtivo ? 'opacity-60 bg-gray-50' : ''}`}>
            <td className="td-name">
                <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10 relative">
                        <img 
                            className={`h-10 w-10 rounded-full object-cover border ${isAtivo ? 'border-gray-200' : 'border-gray-300 grayscale'}`} 
                            src={getPhotoUrl()} 
                            alt={user.name}
                            onError={(e) => {
                                e.target.onerror = null;
                                setImgError(true);
                            }}
                        />
                        <div className={`absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full border-2 border-white ${
                            isExcluido ? 'bg-gray-400' : isAtivo ? 'bg-green-500' : 'bg-red-500'
                        }`}></div>
                    </div>
                    <div className="ml-4">
                        <div className={`text-sm font-medium ${isAtivo ? 'text-gray-900' : 'text-gray-600'}`}>
                            {user.name}
                        </div>
                    </div>
                </div>
            </td>
            
            <td className="text-sm text-gray-700">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200">
                    <Shield size={12} className="mr-1 text-gray-500" />
                    {user.roleName || 'Usuário'}
                </span>
            </td>

            <td className="text-sm text-gray-600 font-mono">
                {user.telefone ? (
                    <span className="flex items-center">
                        <Phone size={12} className="mr-1 text-gray-400" />
                        {user.telefone}
                    </span>
                ) : (
                    '-'
                )}
            </td>
            
            <td className="text-center">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
                    isExcluido ? 'bg-gray-100 text-gray-800 border-gray-200' :
                    isAtivo ? 'bg-green-100 text-green-800 border-green-200' : 
                    'bg-red-100 text-red-800 border-red-200'
                }`}>
                    {isExcluido ? 'Excluído' : isAtivo ? 'Ativo' : 'Inativo'}
                </span>
            </td>
            
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={() => onOpenActions(user)}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default UserRow;